export const dataStorage = {
  apiToken: 'instApiToken',
  tracingId: 'instTracingIds',
  userInfo: 'instUserInfo',
  userId: 'instUserId',
  loggedIn: 'instLoggedIn',
  userAgreement: 'insUserAgreement',
  RMInfo: 'insRMInfo',
}

export const screens = {
  LOGIN_SCREEN: 'LOGIN_SCREEN',
  CANCEL_VERIFICATION_SCREEN: 'CANCEL_VERIFICATION_SCREEN',
  FORGOT_PASSWORD_SCREEN: 'FORGOT_PASSWORD_SCREEN',
  MFA_SCREEN: 'MFA_SCREEN',
  MFA_ANSWER_SCREEN: 'MFA_ANSWER_SCREEN',
  CHANGE_PASSWORD_SCREEN: 'CHANGE_PASSWORD_SCREEN',
  USER_AGREEMENT_SCREEN: 'USER_AGREEMENT_SCREEN',
}

export const apiEndPoint = {
  login: '/instexp.svc/login',
  mfa: '/instexp.svc/mfa',
  mfanswer: '/instexp.svc/mfaAnswer',
  riskAdvice: '/instexp.svc/riskAdvice',
  forgotPassword: '/inst.svc/forgotPassword',
  changePassword: '/instexp.svc/changePassword',
  getUser: '/inst.svc/secure/getInstUser',
  userPreference: '/inst.svc/secure/instUserPreference',
  downloadReport: '/inst.svc/secure/viewInstAcctRpt',
  getAccountReport: '/inst.svc/secure/getInstAcctRpts',
}

export const errorMessage = {
  contactRM: 'To proceed with login, please contact your Relationship Manager.',
  yourReportText:
    'Your Reports information is unavailable at this time. Please try again later.',
  otpFailedAttempts:
    'For your protection, your account has been locked after several failed attempts. For assistance, please contact your Relationship Manager.',
  userIdAndPasswordIncorrect:
    'The User ID and/or password you entered is incorrect. Please try again.',
  defaultError:
    'A problem occured with your account. For assistance, please call Shareholder Services at <a aria-label="800. 3 4 5. 6 6 1 1" href="tel: 8003456611">800.345.6611</a> for assistance.',
  accountLocked:
    'For your protection, your account has been locked. For assistance, please call Shareholder Services at <a aria-label="800. 3 4 5. 6 6 1 1" href="tel: 8003456611">800.345.6611</a> for assistance.',
  tempPasswordExpired:
    'The temporary password you entered has expired. For assistance, please call Shareholder Services at <a aria-label="800. 3 4 5. 6 6 1 1" href="tel: 8003456611">800.345.6611</a> for assistance.',
}

export const LOGIN_RESPONSE_CODES = {
  SUCCESS_LOGIN: 'ALLOW',
  MFA_CHOICE: '3052',
  MFA_CHOICE_2: '3053',
  TEMPORARY_PASSWORD: '2016',
  CREDENTIALS_NOT_ACCEPTED: '7011-2006',
  SSO_LOCKED: '7011-2009',
  SSO_LOCKED_2: '7011-2010',
  BLOCKED_MFA: '7011-3001',
  CONTACT_RM: '7011-3009',
  LOCKED_MFA: '7011-3032',
  TEMP_PASSWORD_EXPIRED: '7011-2030',
  TEMP_PASSWORD_INCREASE_AUTH: 'INCREASEAUTH',
  PHONE_VERIFICATION_STATUS_INACTIVE: 'INACTIVE',
}

export const OTP_RESPONSE_CODES = {
  CREDENTIALS_NOT_ACCEPTED: '7001-3023',
  SSO_LOCKED: '7001-2029',
  BLOCKED_MFA: '7001-3027',
  LOCKED_MFA: '7001-3027',
  OTP_EXPIRED: '7001-3024',
  FYP_INVALID_CODE: 'CTN_FORGOTPASSWORD_1117',
  SUBSCRIBE_USER_INVALID_OTP: 'CTI_ADV_REG_SUBSCRIBEUSER_0004',
  SUBSCRIBE_USER_INVALID_OTP_2: '7083-3023',
}

export const YOUR_REPORTS_TABS = [
  {
    displayValue: 'Recent Reports',
    name: 'recentReports',
    userPreferance: 'RECENT',
  },
  {
    displayValue: 'Archived Reports',
    name: 'archiveReports',
    userPreferance: 'ARCHIEVE',
  },
]

export const REPORT_ORDER = [
  'Requested',
  'Daily',
  'Weekly',
  'Monthly',
  'Quarterly',
  'Annual',
]
